import React from 'react';
import { List, Bubble } from 'tea-component';
import OptionItemInfo from './OptionItemInfo';
import { IOptionsGroupProps, ISelectOptionItemType } from '../type';
import classNames from 'classnames';
import TextBubbles from '@/pages/home/components/TextBubbles';

const OptionsGroup = (props: IOptionsGroupProps) => {
  const {
    value,
    isMatch,
    listHeight: propsHeight,
    options,
    formatMessage,
    onChange,
    groups,
    listTitle,
  } = props || {};

  const groupBy = (options: ISelectOptionItemType[]) => {
    const groups = [] as any;
    options.forEach((opt, index) => {
      const groupKey = opt.groupKey;
      if (index === 0 || groupKey !== options[index - 1].groupKey) {
        groups.push([]);
      }
      groups[groups.length - 1].push(opt);
    });
    return groups;
  };

  const ListItem: React.FC<{ groupList: ISelectOptionItemType[]; }> = (
    props
  ) => {
    const { groupList } = props || {};
    const isGroup = groupList[0].groupKey
      ? !!groups?.[groupList[0].groupKey]
      : false;
    return (
      <>
        {isGroup && (
          <List.GroupLabel>
            {groups?.[groupList[0].groupKey as string]}
          </List.GroupLabel>
        )}
        {groupList.map((item: ISelectOptionItemType) => {
          const {
            value: itemValue,
            disabled,
            info,
            tooltip,
            icon,
            text,
            tooltipPlacement = 'top'
          } = item;
          // info > tooltip > ...tooltip
          if (!item.info && item.tooltip) {
            return (
              <Bubble placement={tooltipPlacement} dark content={tooltip} key={itemValue}>
                <List.Item
                  className={classNames({
                    'tea-list__item--single': !isGroup,
                    'is-selected': value === itemValue,
                  })}
                  key={itemValue}
                  disabled={disabled}
                  onClick={(evt: React.MouseEvent<Element, MouseEvent>) =>
                    onChange(itemValue, evt)
                  }
                >
                  {(icon && typeof icon === 'string') ? <img src={icon} />
                    : icon}
                  {info || tooltip ? (
                    <div
                      className="db-single-select-options-list-item-text"
                      dangerouslySetInnerHTML={{ __html: `${text}` }}
                    />
                  ) : (
                    <TextBubbles
                      className="db-single-select-options-list-item-text"
                      text={
                        <div
                          className="db-single-select-options-list-item-text"
                          dangerouslySetInnerHTML={{ __html: text || '' }}
                        />
                      }
                    />
                  )}
                </List.Item>
              </Bubble>
            );

            // else: info && tooltip, !info && !tooltip, info && !tooltip
          } else {
            return (
              <List.Item
                className={classNames({
                  'tea-list__item--single': !isGroup,
                  'is-selected': value === itemValue,
                })}
                key={itemValue}
                disabled={disabled}
                onClick={(evt: React.MouseEvent<Element, MouseEvent>) =>
                  onChange(itemValue, evt)
                }
              >
                {(icon && typeof icon === 'string') ?  <img src={icon} />
                  : icon}
                {info || tooltip ? (
                  <div
                    className="db-single-select-options-list-item-text"
                    dangerouslySetInnerHTML={{ __html: `${text}` }}
                  />
                ) : (
                  <TextBubbles
                    className="db-single-select-options-list-item-text"
                    text={
                      <div
                        className="db-single-select-options-list-item-text"
                        dangerouslySetInnerHTML={{ __html: text }}
                      />
                    }
                  />
                )}

                {info && <OptionItemInfo infoItem={item} />}
              </List.Item>
            );
          }
        })}
      </>
    );
  };

  return (
    <>
      {isMatch ? (
        // 虚拟滚动隐藏外部滚动条
        <div
          className={`db-single-select-options-list`}
          style={
            propsHeight ? { height: propsHeight, maxHeight: propsHeight } : {}
          }
        >
          <List type="option-group">
            <div className={`db-single-select-options-title`}>{listTitle}</div>
            <>
              {groupBy(options)?.map(
                (item: ISelectOptionItemType[], index: number) => (
                  <ListItem groupList={item} key={index} />
                ),
              )}
            </>
          </List>
        </div>
      ) : (
        <div className="db-single-select-no-result">
          {formatMessage({ id: 'no_result' })}
        </div>
      )}
    </>
  );
};

export default OptionsGroup;
